import { Box, BoxProps } from '@mui/material';
import { transformImagesInHtml } from '@utils/index';

export interface HtmlProps extends BoxProps {
  html?: string;
}

/**
 * Simple wrapper for setting Html directly from EPI
 */
export const Html = ({ html = '', ...rest }: HtmlProps) => {
  return (
    <Box
      className='html-wrapper'
      dangerouslySetInnerHTML={{ __html: transformImagesInHtml(html) }}
      component='span'
      {...rest}
    />
  );
};
